export default __webpack_public_path__ + "static/media/googleFormsIcon.229c2268.svg";